
interface LabelProps {
    label: string | React.ReactNode;
    htmlFor?: string;
    className?: string;
}

export default function Label({ label, htmlFor, className }: LabelProps) {
    return (
        <div>
            <label htmlFor={htmlFor} className={`text-sm capitalize mb-2 relative inline-block !font-aeonikReg font-medium text-labelTextCol ${className}`}>
                {label}
            </label>
        </div>
    );
};